/**
 * API configuration
 */

// Base URL for remaining DigitalOcean serverless functions (forgot password).
const API_BASE =
  process.env.REACT_APP_API_BASE ||
  'https://faas-nyc1-2ef2e6cc.doserverless.co/api/v1/web/fn-a14af637-c32b-4663-8e91-3fbcdf60921a';

export const VPN_FORGOT_PASSWORD_URL = `${API_BASE}/vpn/vpn-forgot-password`;
export const CHECK_USER_PATH = '/api/check-user';
export const GEO_PATH = '/api/geo';
export const PURCHASE_PATH = '/api/purchase';
export const SIGNUP_PATH = '/api/signup';
export const EMAIL_CREDS_PATH = '/api/email-creds';
export const LOGIN_PATH = '/api/login';
const CHECK_USER_PAGES_ORIGIN = 'https://vpn-ui-v2.pages.dev';

function isLocalHost() {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
}

function pagesFunctionUrl(path, envOverride) {
  if (envOverride) {
    return envOverride;
  }
  if (isLocalHost()) {
    return `${CHECK_USER_PAGES_ORIGIN}${path}`;
  }
  return path;
}

export function getCheckUserUrl() {
  return pagesFunctionUrl(CHECK_USER_PATH, process.env.REACT_APP_CHECK_USER_URL);
}

export function getGeoUrl() {
  return pagesFunctionUrl(GEO_PATH, process.env.REACT_APP_GEO_URL);
}

export function getPurchaseUrl() {
  return pagesFunctionUrl(PURCHASE_PATH, process.env.REACT_APP_PURCHASE_URL);
}

export function getSignupUrl() {
  return pagesFunctionUrl(SIGNUP_PATH, process.env.REACT_APP_SIGNUP_URL);
}

export function getEmailCredsUrl() {
  return pagesFunctionUrl(EMAIL_CREDS_PATH, process.env.REACT_APP_EMAIL_CREDS_URL);
}

export function getLoginUrl() {
  return pagesFunctionUrl(LOGIN_PATH, process.env.REACT_APP_LOGIN_URL);
}
